import PropTypes from 'prop-types'

import {atomButtonSizes} from '@s-ui/react-atom-button'
import ComparatorButton from '@adv-mt/mt-comparator-button'
import SearchSave, {searchSaveTrackingOrigins} from '@adv-mt/mt-search-save'

const BASE_CLASS = 'mt-AdsList-StickyButtons'

const StickyButtons = ({
  showSearchSave,
  createdAlert,
  initialSearch,
  isNetOpen,
  setIsNetOpen,
  comparatorSelectedAds,
  isComparatorOpen,
  onToggleComparator
}) => {
  const showComparatorButton = comparatorSelectedAds?.length > 0

  return (
    <div className={BASE_CLASS}>
      {showSearchSave && (
        <SearchSave
          createdAlert={createdAlert}
          isFullWidth={false}
          search={initialSearch}
          trackingOrigin={searchSaveTrackingOrigins.ADS_LIST}
          showTooltip={false}
          hideText={showComparatorButton}
          size={atomButtonSizes.LARGE}
        />
      )}
      {showComparatorButton && (
        <ComparatorButton
          comparatorSelectedAds={comparatorSelectedAds}
          isOpen={isComparatorOpen}
          onToggle={onToggleComparator}
        />
      )}
    </div>
  )
}

StickyButtons.displayName = 'StickyButtons'

StickyButtons.propTypes = {
  showSearchSave: PropTypes.bool,
  createdAlert: PropTypes.bool,
  initialSearch: PropTypes.object,
  isNetOpen: PropTypes.bool,
  setIsNetOpen: PropTypes.func,
  comparatorSelectedAds: PropTypes.array,
  isComparatorOpen: PropTypes.bool,
  onToggleComparator: PropTypes.func
}

export default StickyButtons
